// extracted by mini-css-extract-plugin
export default {"rating":"wA-z","numberOfStars":"xA-z","count":"yA-z","barGraphSpacing":"zA-z","barGraph":"AA-z"};